import { render, staticRenderFns } from "./ed-whiteboard-menu-history.component.vue?vue&type=template&id=437eebbe&scoped=true&"
import script from "./ed-whiteboard-menu-history.component.ts?vue&type=script&lang=ts&"
export * from "./ed-whiteboard-menu-history.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-whiteboard-menu-history.component.scss?vue&type=style&index=0&id=437eebbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437eebbe",
  null
  
)

export default component.exports